import React, { useState } from 'react';
import './App.css';
import Home from './components/Home';
import BillManagement from './components/BillManagement';
import SalesBill from './components/SalesBill';
import PurchaseBill from './components/PurchaseBill';
import Statistics from './components/Statistics';

function App() {
  const [activeTab, setActiveTab] = useState('home');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'home':
        return <Home setActiveTab={setActiveTab} />;
      case 'bill':
        return <BillManagement />;
      case 'sales':
        return <SalesBill />;
      case 'purchase':
        return <PurchaseBill />;
      case 'statistics':
        return <Statistics />;
      default:
        return <Home setActiveTab={setActiveTab} />;
    }
  };

  return (
    <div className="App">
      <nav className="navbar">
        <h1>管家婆工具</h1>
        <div className="nav-links">
          <button 
            className={activeTab === 'home' ? 'active' : ''} 
            onClick={() => setActiveTab('home')}
          >
            首页
          </button>
          <button 
            className={activeTab === 'bill' ? 'active' : ''} 
            onClick={() => setActiveTab('bill')}
          >
            账单管理
          </button>
          <button 
            className={activeTab === 'sales' ? 'active' : ''} 
            onClick={() => setActiveTab('sales')}
          >
            出货账单
          </button>
          <button 
            className={activeTab === 'purchase' ? 'active' : ''} 
            onClick={() => setActiveTab('purchase')}
          >
            进货账单
          </button>
          <button 
            className={activeTab === 'statistics' ? 'active' : ''} 
            onClick={() => setActiveTab('statistics')}
          >
            统计分析
          </button>
        </div>
      </nav>
      <div className="content">
        {renderTabContent()}
      </div>
    </div>
  );
}

export default App;
